var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineWallet3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 11.9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H7zM1.25 11.15V6.53c0-2.45 1.99-4.44 4.44-4.44h5.62c2.57 0 4.44 1.71 4.44 4.06 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-1.76-1.53-2.56-2.94-2.56H5.69c-1.62 0-2.94 1.32-2.94 2.94v4.62a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21.9c-2.62 0-4.75-2.13-4.75-4.75v-7C1.25 7.53 3.38 5.4 6 5.4h10c2.62 0 4.75 2.13 4.75 4.75v1.45c0 .41-.34.75-.75.75h-1.08c-.35 0-.67.13-.9.37l-.01.01c-.33.33-.46.79-.34 1.24.15.56.74.97 1.4.97H20c.41 0 .75.34.75.75v1.45c0 2.63-2.13 4.76-4.75 4.76H6zM2.75 10.15v7c0 1.79 1.46 3.25 3.25 3.25h10c1.79 0 3.25-1.46 3.25-3.25v-.7h-.18c-1.35 0-2.52-.85-2.85-2.08-.26-.97.02-2 .73-2.7.52-.53 1.22-.82 1.97-.82h.33v-.7c0-1.79-1.46-3.25-3.25-3.25H6c-1.79 0-3.25 1.46-3.25 3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.04 16.45c-1.51 0-2.79-1.12-2.91-2.56-.08-.83.22-1.64.82-2.23.5-.52 1.21-.81 1.96-.81h2.05c.98 0 1.78.79 1.78 1.77v2.06c.01.98-.79 1.77-1.77 1.77h-1.93zm-1.02-3.73c-.29.28-.43.66-.39 1.04.05.66.69 1.19 1.41 1.19h1.93c.15 0 .28-.12.28-.27v-2.06c0-.15-.13-.27-.28-.27h-2.05c-.35 0-.67.13-.9.37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineWallet3);
export default __webpack_public_path__ + "static/media/vuesax-outline-wallet-3.e2e5876c2e15541222ff701da13d8b21.svg";
export { ForwardRef as ReactComponent };